import React, { Component, PropTypes } from 'react';
import LinkButton from 'components/LinkButton/LinkButton';
import reactTimeout from 'react-timeout';

import './EmailDealResult.scss';

export class EmailDealResult extends Component {
  static propTypes = {
    emailDealResult: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    setTimeout: PropTypes.func.isRequired,
  };

  state = {
    timeUntilClose: 5,
  };

  componentDidMount() {
    this.props.setTimeout(this.tick, 1000);
  }

  tick = () => {
    const { timeUntilClose } = this.state;
    if (timeUntilClose > 1) {
      this.setState({ timeUntilClose: timeUntilClose - 1 });
      this.props.setTimeout(this.tick, 1000);
    } else {
      this.props.close();
    }
  };

  handleCloseClick = (event) => {
    event.preventDefault();
    this.props.close();
  };

  render() {
    const { emailDealResult } = this.props;
    const { timeUntilClose } = this.state;

    return (
      <div className="email-deal-result">
        <h2>Deal sent</h2>
        <div className="email-deal-result__message">
          {
            emailDealResult && (
              <div>
                <h4>You have successfully shared your basket</h4>
                <div>This window will close in { timeUntilClose } seconds</div>
              </div>
            )
          }

          {
            !emailDealResult && (
              <div>There was an error. Please try again later</div>
            )
          }
        </div>
        <LinkButton color="blue" type="secondary" onClick={this.handleCloseClick}>Close Window</LinkButton>
      </div>
    );
  }
}

export default reactTimeout(EmailDealResult);



/** WEBPACK FOOTER **
 ** ./src/components/EmailDeal/EmailDealResult.jsx
 **/